interface StrengthBars {
  opacity: number;
  visible: boolean;
}

const specialChar = /[!@#$%^&*(),.?":{}|<>]/;
const uppercaseChar = /[A-Z]/;
const lowercaseChar = /[a-z]/;
const numberChar = /[0-9]/;

export const calculatePasswordStrength = (password: string) => {
  let criteriaMet = 0;

  if (specialChar.test(password)) criteriaMet++;
  if (uppercaseChar.test(password)) criteriaMet++;
  if (lowercaseChar.test(password)) criteriaMet++;
  if (numberChar.test(password)) criteriaMet++;

  return Math.min(criteriaMet, 4);
}

export const updateStrengthBars = (
    password: string, strength: number, strengthBars: StrengthBars[]
  ) => {

  strengthBars[0].visible = !specialChar.test(password);
  strengthBars[1].visible = !uppercaseChar.test(password);
  strengthBars[2].visible = !lowercaseChar.test(password);
  strengthBars[3].visible = !numberChar.test(password);

  let opacity = 1;
  for (let i = 0; i < strengthBars.length; i++) {
    strengthBars[i].opacity = strength > i ? 1 : opacity;
    opacity = (opacity - 0.3);
  }

  return strengthBars;
}

export const updateStrengthText = (strength: number) => {
  switch (strength) {
    case 0:
    case 1:
      return 'Too Weak';
    case 2:
      return 'Weak';
    case 3:
      return 'Average';
    case 4:
      return 'Strong';
    default:
      return 'Too Weak';
  }
}
